{{#if showPageination}}
<div class="row m-t-5">
    <div class="col-xs-3">
        <button class="btn btn-white pagination-btn js-prev {{#unless canPrev}}disabled{{/unless}}" {{#unless canPrev}}disabled{{/unless}}>
            <i class="fa fa-caret-left"></i>
        </button>
    </div>
    <div class="col-xs-6">
        {{#if count}}
        <div class="m-t-5 text-center">
            {{from}} - {{till}} / {{count}}
        </div>
        {{/if}}
    </div>
    <div class="col-xs-3">
        <button class="btn btn-white pagination-btn pull-right js-next {{#unless canNext}}disabled{{/unless}}" {{#unless canNext}}disabled{{/unless}}>
            <i class="fa fa-caret-right"></i>
        </button>
    </div>
</div>
{{/if}}
<div class="row m-t-5">
    <div class="col-xs-12">
        <ul class="ct-dropdown-menu">
            {{#each items}}
            <li>
                <a href="{{#if link}}{{link}}{{else}}#{{/if}}" data-device-id="{{id}}">
                    <span>
                        {{#if icon}}<i class="m-l-5 {{icon}}"></i> {{/if}}
                        {{name}} {{#if locked}}<i class="fa fa-lock"></i>{{/if}}
                    </span>
                </a>
            </li>
            {{/each}}
            {{#if oldValue}}
                <li class="separator"></li>
                <li>
                    <a href="{{#if link}}{{link}}{{else}}#{{/if}}" data-device-id="{{oldValue}}">
                        <span>
                            {{#if oldIcon}}<i class="m-l-5 {{oldIcon}}"></i> {{/if}}
                            {{oldText}}
                        </span>
                    </a>
                </li>
            {{/if}}
        </ul>
    </div>
</div>
